export const AVAILABILITY_KEYS = {
  all: ['availability'],
  doctors: () => [...AVAILABILITY_KEYS.all, 'doctors'].join('/'),
  weekly: (doctorId: string) =>
    [...AVAILABILITY_KEYS.all, 'weekly', doctorId].join('/'),
  overrides: (doctorId: string, startDate?: string, endDate?: string) =>
    [
      ...AVAILABILITY_KEYS.all,
      'overrides',
      doctorId,
      startDate ?? '',
      endDate ?? '',
    ].join('/'),
  slotDurationRules: (doctorId: string) =>
    [...AVAILABILITY_KEYS.all, 'slot-duration-rules', doctorId].join('/'),
  slots: {
    doctor: (doctorId: string, date: string) =>
      [...AVAILABILITY_KEYS.all, 'slots', doctorId, date].join('/'),
    multiDoctor: (date: string, doctorIds?: Array<string>) =>
      [
        ...AVAILABILITY_KEYS.all,
        'slots',
        'multi',
        date,
        ...(doctorIds || []),
      ].join('/'),
    check: (doctorId: string, date: string, time: string) =>
      [...AVAILABILITY_KEYS.all, 'slots', 'check', doctorId, date, time].join(
        '/',
      ),
  },
  monthStatusExtended: (month: string, doctorId?: string) =>
    [
      ...AVAILABILITY_KEYS.all,
      'month-status-extended',
      month,
      doctorId ?? '',
    ].join('/'),
}
